import { ToastManager } from '../../../ToastManager';

import { useI18n } from '../../../hooks/useI18nFormatters';

import { glyph } from '../../../theme/glyph';

import { ContextMenuContent } from '../../../components/common/context-menu/ContextMenuContent';
// import { DeveloperMenu } from '../../../components/common/context-menu/DeveloperMenu';

import { notificationSettingsStore } from './NotificationSettingsStore';

export function NotificationSettingsTableOwnersContextMenuContent(props) {
  const { i18n } = useI18n();

  function onAction(key) {
    switch (key) {
      case 'delete':
        notificationSettingsStore
          .deleteNotifications({ uri: props.uri })
          .then(() => {
            ToastManager.add({
              message: i18n.messageFormatter('settings.system.notificationsDeletedMessage', {
                name: props.name,
              }),
            });
          })
          .catch(ToastManager.handleError);
        break;
      default:
        break;
    }
  }

  return (
    <ContextMenuContent.List>
      {/* <DeveloperMenu onIdRequest={() => user?.id} onResourceRequest={() => user} /> */}

      <ContextMenuContent.ListItem
        label={i18n.messageFormatter('settings.system.notificationsDeleteButtonLabel')}
        variant="danger"
        icon={glyph.core.trashFill}
        onPress={() => onAction('delete')}
      />
    </ContextMenuContent.List>
  );
}
